import { FIRM_CATEGORY_URL } from "../../helpers/api.routes";
import { requests } from "../../helpers/api.services";

export const AdminFirmCategoryService = {
  getAll: (params: any) => requests.get(`${FIRM_CATEGORY_URL}`, params),
  create: (params: any) =>
    requests.post(`${FIRM_CATEGORY_URL}`, params, true),
  updatePosition: (params: any) =>
    requests.patch(`${FIRM_CATEGORY_URL}`, params),
  getSingle: (id: number) => requests.get(`${FIRM_CATEGORY_URL}/${id}`),
  update: (params: any, id: number) =>
    requests.post(`${FIRM_CATEGORY_URL}/${id}`, params, true),
  delete: (id: number) => requests.delete(`${FIRM_CATEGORY_URL}/${id}`),
};
